import * as React from 'react';
import { api } from 'services';
import type { CreateServiceOrderObservationPayload } from 'contracts/service-orders';

export const useCreateObservation = () => {
  const createObservation = React.useCallback(
    async (data: CreateServiceOrderObservationPayload) => {
      await api.post('/inventory/service-order-observations', data);
    },
    []
  );

  return {
    createObservation,
  };
};
